module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area04_img_cn.ce0dc400.png";